import React from 'react';

import Row from 'sharedreact/components/Row';
import Tab from 'sharedreact/components/Tab';
import { translate } from 'sharedreact/utils/LanguageSupport';

import ClientNames from 'workspaces/launcher/components/clientapps/ClientNames';
import DownloadCard from 'workspaces/launcher/components/clientapps/DownloadCard';

import __BUILD_VERSION__ from 'workspaces/launcher/utils/BuildVersion';

type Props = {
  index: number,
  activeTab: number,
  language: string,
  canDownloadAgent: boolean,
  canDownloadPitStopEditor: boolean,
  canDownloadArtProEditor: boolean,
  canDownloadConnectionTools: boolean,
  canDownloadFlexoWorkflowEditors: boolean,
  
  createDownloadUrl: (clientName: string) => string
};

class ToolsTab extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      index, activeTab,
      language, // eslint-disable-line no-unused-vars
      createDownloadUrl,
      canDownloadAgent,
      canDownloadPitStopEditor,
      canDownloadArtProEditor,
      canDownloadConnectionTools,
      canDownloadFlexoWorkflowEditors
    } = this.props;

    const scriptRunnerIcon: string = 'static/media/ae_scriptrunner.png?' + __BUILD_VERSION__;
    const artProEditorIcon: string = 'static/media/ae_artproactionlisteditor.png?' + __BUILD_VERSION__;
    const pitstopEditorIcon: string = 'static/media/ae_pitstopprofileeditor.png?' + __BUILD_VERSION__;
    const agentIcon: string = 'static/media/ae_agent.png?' + __BUILD_VERSION__;
    const appLauncherIcon: string = 'static/media/ae_applauncher.png?' + __BUILD_VERSION__;
    const syncerIcon: string = 'static/media/ae_syncer.png?' + __BUILD_VERSION__;
    // still waiting for icon for flexo workflow editors
    const aeIcon: string = 'static/media/ae_client.png?' + __BUILD_VERSION__;

    let rowIndex = 0;

    return (
      <Tab index={index} activeIndex={activeTab}>
        <div className='webappslauncher-tab-scroll-container'>
          <div className='webappslauncher-tab-strech-container'>
            {canDownloadArtProEditor
            ? <Row useAlternateColor={rowIndex++ % 2 === 0}>
              <DownloadCard id='ae_card_download_artproeditor'
                icon={artProEditorIcon}
                title={translate('launcher.clientapps.artproeditor')}
                description={translate('launcher.clientapps.artproeditor.description')}
                downloadTitle={translate('launcher.clientapps.download')}
                downloadUrl={createDownloadUrl(ClientNames.ARTPRO_ACTIONLIST_EDITOR)}
              />
            </Row>
            : undefined}
            {canDownloadAgent
            ? <Row useAlternateColor={rowIndex++ % 2 === 0}>
              <DownloadCard id='ae_card_download_aeagent'
                icon={agentIcon}
                title={translate('launcher.clientapps.aeagent')}
                description={translate('launcher.clientapps.aeagent.description')}
                downloadTitle={translate('launcher.clientapps.download')}
                downloadUrl={createDownloadUrl(ClientNames.AE_AGENT)}
              />
            </Row>
            : undefined}
            {canDownloadPitStopEditor
            ? <Row useAlternateColor={rowIndex++ % 2 === 0}>
              <DownloadCard id='ae_card_download_pitstopeditor'
                icon={pitstopEditorIcon}
                title={translate('launcher.clientapps.pitstopeditor')}
                description={translate('launcher.clientapps.pitstopeditor.description')}
                downloadTitle={translate('launcher.clientapps.download')}
                downloadUrl={createDownloadUrl(ClientNames.PITSTOP_PROFILE_EDITOR)}
              />
            </Row>
            : undefined}
            <Row useAlternateColor={rowIndex++ % 2 === 0}>
              <DownloadCard id='ae_card_download_scriptrunner'
                icon={scriptRunnerIcon}
                title={translate('launcher.clientapps.scriptrunner')}
                description={translate('launcher.clientapps.scriptrunner.description')}
                downloadTitle={translate('launcher.clientapps.download')}
                downloadUrl={createDownloadUrl(ClientNames.SCRIPT_RUNNER)}
              />
            </Row>
            {canDownloadConnectionTools
            ? <Row useAlternateColor={rowIndex++ % 2 === 0}>
              <DownloadCard id='ae_card_download_eskoeditorconnectiontools'
                className='webappslauncher-download-card-package'
                title={translate('launcher.clientapps.eskoeditorconnectiontools')}
                description=''
                downloadTitle={translate('launcher.clientapps.download')}
                downloadUrl={createDownloadUrl(ClientNames.EDITOR_CONNECTION_TOOLS)}
              />
              <DownloadCard id='ae_card_download_aeapplauncher'
                icon={appLauncherIcon}
                buttonType='none'
                title={translate('launcher.clientapps.aeapplauncher')}
                description={translate('launcher.clientapps.aeapplauncher.description')}
                downloadTitle={translate('launcher.clientapps.download')}
              />
              <DownloadCard id='ae_card_download_aesyncer'
                icon={syncerIcon}
                buttonType='none'
                title={translate('launcher.clientapps.aesyncer')}
                description={translate('launcher.clientapps.aesyncer.description')}
                downloadTitle={translate('launcher.clientapps.download')}
              />
            </Row>
            : undefined}
            {canDownloadFlexoWorkflowEditors
            ? <Row useAlternateColor={rowIndex++ % 2 === 0}>
              <DownloadCard id='ae_card_download_flexoworkfloweditors'
                icon={aeIcon}
                title={translate('launcher.clientapps.flexoworkfloweditors')}
                description={translate('launcher.clientapps.flexoworkfloweditors.description')}
                downloadTitle={translate('launcher.clientapps.download')}
                downloadUrl={createDownloadUrl(ClientNames.FLEXO_WORKFLOW_EDITORS)}
              />
            </Row>
            : undefined}
          </div>
        </div>
      </Tab>
    );
  }
}

export default ToolsTab;
